import { Controller } from "@hotwired/stimulus"
import {TomInput} from "tom-select/dist/cjs/types/core";

export default class extends Controller {
  static targets = [ "tomSelect", "typeSelect" ];
  declare readonly tomSelectTarget: TomInput;
  declare readonly typeSelectTarget: HTMLSelectElement;

  connect() {
    setTimeout(() => {
      this.updateTomSelect(this.typeSelectTarget.selectedOptions?.[0]);
    }, 500);
  }

  changeType = e => {
    this.updateTomSelect(e.target.selectedOptions[0]);
  }

  updateTomSelect = (selectedOpt: HTMLOptionElement) => {
    const { path } = selectedOpt?.dataset ?? {};
    if (!path?.length) return this.tomSelectTarget.removeAttribute('data-tom-select-search-path-value');
    this.tomSelectTarget.setAttribute('data-tom-select-search-path-value', path);
  }
}
